import { createContext } from 'react';
export default /*#__PURE__*/createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tabs/es/TabContext.js
// module id = 430
// module chunks = 0